module.exports = __webpack_public_path__ + "img/logo-text.304ac6a4.svg";